import { debounce, toLower } from "lodash-es";
import React, { ChangeEvent, useEffect, useState } from "react";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import "./OwDebouncedInput.scss";

type Props = {
    wrapperClassName?: string;
    confirmAdd?: string;
    title: string;
    className?: string;
    placeholder?: string;
    isRequired?: boolean;
    defaultClassName?: string;
    performingSearch: boolean;
    fn: (e: ChangeEvent<any>) => void;
    value: string;
};

const OwDebouncedInput = (props: Props) => {
    const [typeahead, setTypeahead] = useState(props.value || "");

    useEffect(() => {
        if (props.value !== typeahead) {
            setTypeahead(props.value);
        }
    }, [props.value]);

    const typeaheadApiFn = (event: React.KeyboardEvent<HTMLInputElement>) => {
        props.fn(event);
    };

    const debouncedTypeaheadApiFn = debounce(typeaheadApiFn, 800);

    const persistTypeaheadApiFn = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Escape" || e.keyCode === 27) {
            setTypeahead("");

            return;
        }

        const value = e.currentTarget.value;

        e.persist();

        debouncedTypeaheadApiFn(e);
        setTypeahead(value);
    };

    const isDisabled = false;

    return (
        <div className={"OwDebouncedInput position-relative"}>
            <div className={" w-100 Typeahead " + props.wrapperClassName}>
                <div className={props.confirmAdd ? "input-group" : ""}>
                    <OwInputWrapper
                        // onKeyDownFn={this.props.onKeyDownFn}
                        title={props.title}
                        className={props.className + " "}
                        name={"typeahead_item"}
                        value={typeahead}
                        fn={persistTypeaheadApiFn}
                        placeholder={toLower(props.placeholder)}
                        disabled={isDisabled}
                        autoComplete={false}
                        isRequired={props.isRequired || false}
                        defaultClassName={props.defaultClassName}
                    />
                    {props.performingSearch ? (
                        <span className={"activity me-2"}>
                            <i className={"fas fa-sync fa-spin"} />
                        </span>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default OwDebouncedInput;
